var _rect, _path, _path2, _rect2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666748,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F5F7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6689 29.0038H15.6648C13.4547 29.0038 11.6631 27.2122 11.6631 25.0021V16.9988C11.6631 15.8937 12.5589 14.9979 13.6639 14.9979H27.6698C28.7748 14.9979 29.6706 15.8937 29.6706 16.9988V25.0021C29.6706 27.2122 27.879 29.0038 25.6689 29.0038Z",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6653 14.9979V12.997C16.6653 11.892 17.5611 10.9962 18.6661 10.9962H22.6678C23.7728 10.9962 24.6686 11.892 24.6686 12.997V14.9979",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.666,
    y: 18.9996,
    width: 4.00167,
    height: 3.00125,
    rx: 0.5,
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6677 20.5002H26.1692C28.103 20.5002 29.6706 18.9326 29.6706 16.9988V16.9988",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.666 20.5002H15.1645C13.2307 20.5002 11.6631 18.9326 11.6631 16.9988V16.9988",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool);
export default __webpack_public_path__ + "static/media/School.93325b8c1959ac220ae512c25ea79ba7.svg";
export { ForwardRef as ReactComponent };